import { Button } from '@components/ui'
import WYSIWYG from '@components/ui/WYSIWYG/WYSIWYG'
import config from '@config/seo_meta.json'
import Image from 'next/image'
import Link from 'next/link'
interface Props {
  slice: any
}

const HeroBlock = ({ slice }: Props) => {
  const imageUrl = slice?.primary?.image?.url
  const imageAlt = slice?.primary?.image?.alt
  const title = slice?.primary?.title
  const description = slice?.primary?.description
  const buttonText = slice?.primary?.button_text
  const buttonLink = slice?.primary?.button_link
  return (
    <div className="grid w-full grid-cols-4 gap-x-6 lg:grid-cols-12 lg:gap-x-8">
      <div className="relative order-2 col-span-4 flex flex-col items-center  justify-center lg:order-1">
        {title && (
          <div className="heading-mobile-3 lg:heading-3 pb-6 text-dark-grey lg:pb-8">
            {title}
          </div>
        )}
        {description && (
          <div className="heroBlock pb-8 text-dark-grey lg:pb-0">
            <WYSIWYG content={description} />
          </div>
        )}
        {buttonText && buttonLink && (
          <div className="relative  w-full lg:absolute lg:bottom-0">
            <Link href={buttonLink} target="_blank">
              <Button className="w-full">{buttonText}</Button>
            </Link>
          </div>
        )}
      </div>
      <div className="order-1 col-span-4 flex flex-col pb-13 lg:order-2 lg:col-span-6 lg:col-start-7 lg:pb-0 ">
        <div className="relative aspect-square w-full">
          <Image
            fill
            style={{ objectFit: 'cover' }}
            placeholder="blur"
            src={imageUrl || '/product-img-placeholder.svg'}
            blurDataURL={`${imageUrl}&blur=500`}
            alt={imageAlt || config.openGraph.images[0].alt}
          />
          {imageAlt && (
            <div className="body-2 absolute -bottom-7 right-0">{imageAlt}</div>
          )}
        </div>
      </div>

      <style jsx global>{`
        .heroBlock .wysiwyg ul li {
          background-image: url(/check.svg);
          background-repeat: no-repeat;
          line-height: 24px;
          list-style-position: inside;
          list-style-type: none;
          padding-left: 32px;
          padding-bottom: 8px;
        }
        .heroBlock .wysiwyg ul {
          padding-top: 16px;
          padding-bottom: 16px;
        }
        @media (min-width: 1024px) {
          .heroBlock .wysiwyg ul {
            padding-top: 24px;
            padding-bottom: 24px;
          }
        }
      `}</style>
    </div>
  )
}

export default HeroBlock
